import { fg } from '@atlaskit/platform-feature-flags/fg';

/**
 * Controls Help Center's adoption of the editor and renderer's `max` appearance.
 * The editor supports `max` without an experiment; this gate independently rolls
 * out the wider hub canvas and extension layouts in both edit and view modes.
 */
export const isHubMaxWidthAppearanceEnabled = (): boolean => fg('hubs_jsm_max_width_appearance');
